// Runs an AI call in the background: the API answers 202 with a task id and
// the result is polled, so long audios are not cut by the 30s request limit.
// Resolves like the old synchronous call ({ data }) and rejects like an axios
// error ({ response: { data, status } }), so callers keep their handling.
const POLL_MS = 1200;
const MAX_WAIT_MS = 4 * 60 * 1000;

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export async function runAiTask(axios, url, payload, config = {}) {
  let body = payload;
  if (typeof FormData !== "undefined" && payload instanceof FormData) payload.append("async", "1");
  else body = { ...payload, async: 1 };

  const first = await axios.post(url, body, { skipGlobalErrorHandler: true, ...config });
  if (first.status !== 202 || !first.data || !first.data.task_id) return first;

  const started = Date.now();
  while (Date.now() - started < MAX_WAIT_MS) {
    await sleep(POLL_MS);
    let res;
    try {
      res = await axios.get(`/api/v1/ai_tasks/${first.data.task_id}`, { skipGlobalErrorHandler: true });
    } catch (e) {
      continue; // a network blip: keep waiting
    }
    const data = res.data || {};
    if (data.status === "done") return { data };
    if (data.status === "failed") {
      const STATUS = { rate_limit_exceeded: 429, validation_error: 422, insufficient_data: 422, invalid_response: 422, service_unavailable: 503 };
      const status = STATUS[data.error_type] || 500;
      const err = new Error(data.error || "Erro na IA");
      err.response = { data, status };
      throw err;
    }
  }
  const err = new Error("A IA demorou mais que o esperado. Tente de novo.");
  err.response = { data: { success: false, error: err.message, error_type: "timeout" }, status: 504 };
  throw err;
}
